import { render, staticRenderFns } from "./WalletConfig.vue?vue&type=template&id=e3154a8c&scoped=true"
import script from "./WalletConfig.vue?vue&type=script&lang=js"
export * from "./WalletConfig.vue?vue&type=script&lang=js"
import style0 from "./WalletConfig.vue?vue&type=style&index=0&id=e3154a8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3154a8c",
  null
  
)

export default component.exports